/* eslint-disable no-nested-ternary */
import React from 'react';
import { Controller, useFieldArray } from 'react-hook-form';
import { Autocomplete, Button, TextField } from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';

const ProcessTemplateMaterialForm = ({
  control,
  stepIndex,
  material,
  product,
  alternativeName = null,
  watch,
}) => {
  const { append, remove, fields } = useFieldArray({
    control,
    name: alternativeName || `steps[${stepIndex}].materials`,
  });

  if (!material?.rows) {
    return <div></div>;
  }

  return (
    <div>
      <div className="py-2 flex flex-wrap">
        {_.map(fields, (_field, index) => (
          <div className="w-full lg:w-1/2 flex  my-2" key={_field.id}>
            <div className="w-4/5 px-2">
              <Controller
                name={
                  alternativeName
                    ? `${alternativeName}[${index}].materials[${index}].material`
                    : `steps[${stepIndex}].materials[${index}].material`
                }
                defaultValue={
                  alternativeName
                    ? watch(
                        `${alternativeName}[${index}].materials[${index}].material`,
                      )
                    : product?.steps?.[stepIndex]?.materials?.[index]?.material
                }
                control={control}
                render={({ field }) => (
                  <div>
                    <Autocomplete
                      {...field}
                      size={'small'}
                      onChange={(e, newValue) => {
                        field.onChange(newValue);
                      }}
                      options={material?.rows}
                      getOptionLabel={(option) =>
                        `${option?.type_code || ''} ${option?.name || ''} `
                      }
                      required
                      renderInput={(params) => (
                        <TextField {...params} label="เลือกวัตถุดิบ" />
                      )}
                    />{' '}
                  </div>
                )}
              />
            </div>
            <div className="w-1/5 px-2">
              <Button
                size="small"
                variant="contained"
                color="error"
                onClick={() => remove(index)}
              >
                ลบ
              </Button>
            </div>
          </div>
        ))}
      </div>
      <div className="flex">
        <Button size="small" variant="contained" onClick={() => append({})}>
          เพิ่ม
        </Button>
      </div>
    </div>
  );
};

export default ProcessTemplateMaterialForm;

ProcessTemplateMaterialForm.propTypes = {
  control: PropTypes.func,
  stepIndex: PropTypes.number,
  material: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.object),
  }),
  product: PropTypes.shape({
    steps: PropTypes.arrayOf(PropTypes.object),
  }),
  alternativeName: PropTypes.string,
  watch: PropTypes.func,
};
